/**
 * Resolves the video tutorial link for a given service, operation and country.
 * Priority: specificTutorials[countryCode][serviceId][videoKey] > fallback general general[videoKey]
 */
export function resolveVideoLink(appData, { serviceId, operation, countryCode }) {
  const tutorials = appData?.general?.specificTutorials;
  
  // Normalize operation to video key
  const videoKey = (operation === 'withdraw' || operation === 'sell') 
    ? 'withdrawVideoLink' 
    : 'rechargeVideoLink';

  // 1. Try country specific for this service
  const byCountry = tutorials?.[countryCode]?.[serviceId]?.[videoKey];
  if (byCountry) return byCountry;

  // 2. Fallback to global general link
  return appData?.general?.[videoKey] || '';
}
